// 系统状态码
const SYSTEM_RESPONSE_CODE = {
  warning: 294,
  notFound: 404,
  errorDiy: 295,
  confirm : 296,
};

//用户类型
var userType = {
  Normal: 0,
  Teacher: 1,
  Student: 2,
  Sa: 3,
  Deployer: 4,
  SchoolAdmin: 5,
};

var fileType = {
  Normal: "0",
  Mp3File: "1",
  Mp4File: "2",
  TxtFile: "3",
  DocFile: "4",
  ImgFile: "5",
  PptFile: "6",
  PdfFile: "7",
  XlsFile: "8",
  ZipFile: "9",
};

var keyCodes = {
  esc: 27,
  left: 37,
  right: 39,
  up: 38,
  down: 40,
};

var MaterialSubjectType = {
  Normal: 0,
  Translate: 1,
  singleSelect: 2,
  WordReplacement: 3,
  OptionError: 4,
  Reading: 5,
  Cloze: 6,
};

var subjectType = {
  Translate: "translate",
  SingleSelect: "singleSelect",
  WordReplacement: "wordReplacement",
  OptionError: "optionError",
  Reading: "reading",
  Cloze: "cloze",
};

function getSubjectType(type){
  switch (type) {
    case MaterialSubjectType.Translate:
      return subjectType.Translate;
    case MaterialSubjectType.singleSelect:
      return subjectType.SingleSelect;
    case MaterialSubjectType.WordReplacement:
      return subjectType.WordReplacement;
    case MaterialSubjectType.OptionError:
      return subjectType.OptionError;
    case MaterialSubjectType.Reading:
      return subjectType.Reading;
    case MaterialSubjectType.Cloze:
      return subjectType.Cloze;
    default:
      return "未知";
  }
}

function getSubjeceTypeText(type) {
  switch (type) {
    case subjectType.Translate:
      return "翻译";
    case subjectType.SingleSelect:
      return "词汇选择";
    case subjectType.WordReplacement:
      return "同义替换";
    case subjectType.OptionError:
      return "语法改错";
    case subjectType.Reading:
      return "阅读理解";
    case subjectType.Cloze:
      return "完形填空";
    default:
      return "未知";
  }
}

function translateSubjectTypeToMaterialType(type) {
  const index = Object.values(subjectType).indexOf(type);
  if (index < 0) return MaterialSubjectType.Normal;
  return index + 1;
}

var catalogType = {
  root: "0",
  chapter: "1",
  section: "2",
  classhour: "3",
  getText(type) {
    switch (type) {
      case catalogType.root:
        return "目录节点";
      case catalogType.chapter:
        return "章";
      case catalogType.section:
        return "节";
      default:
        return "课时";
    }
  },
  getParentType(type) {
    let parentNumber = Number(type) - 1;
    if (parentNumber < 0) parentNumber = 0;
    return "" + parentNumber;
  },
  getChildType(type) {
    let childNumber = Number(type) + 1;
    if (childNumber > Number(catalogType.classhour)) {
      childNumber = Number(catalogType.classhour);
    }
    return "" + childNumber;
  },
};

//目录级别
var dicLevel = {
  one: 1, //一级目录
  two: 2, //二级目录
};
var homeworkStateType = {
  unSubmitted: 0,
  submitted: 1,
  corrected: 2,
};

var bookCatalogType = {
  root: "0",
  catalogue: "1", //目录
  classhour: "3", //课时
  getText(type) {
    switch (type) {
      case catalogType.root:
        return "根节点";
      case catalogType.catalogue:
        return "目录";
      case catalogType.classhour:
        return "课时";
      default:
        return "目录";
    }
  },
};

export {
  userType,
  fileType,
  keyCodes,
  MaterialSubjectType,
  subjectType,
  getSubjeceTypeText,
  catalogType,
  dicLevel,
  homeworkStateType,
  bookCatalogType,
};

/**
 * correct type enum for statistics
 */
const CORRECT_TYPE = {
  teacher: 0,
  student: 1,
};

/**
 * category type enum for statistic
 */
const CATEGORY_LEVEL = {
  bigCategory: 0,
  smallCategory: 1,
};

/**
 * sort base type for statistic
 */
const STATISTICS_SORT_BASE = {
  teacher: "teacher",
  student: "student",
};

function getSceneList(list) {
  let text = null;
  let classroom = null;
  let practice = null;
  let exam = null;
  let homework = null;
  if (list && list.length) {
    list.$$each((item) => {
      switch (item) {
        case "1":
          classroom = "课堂教学";
          break;
        case "2":
          practice = "自主训练";
          break;
        case "3":
          exam = "考试";
          break;
        case "4":
          homework = "课后作业";
          break;
        default:
          break;
      }
    });
    if (classroom) {
      text = classroom;
    }
    if (practice) {
      text = text ? text + "," + practice : practice;
    }
    if (exam) {
      text = text ? text + "," + exam : exam;
    }
    if (homework) {
      text = text ? text + "," + homework : homework;
    }
    return text;
  } else {
    return text;
  }
}

function getDiffictluty(type) {
  let star = null;
  if (type) {
    switch (type) {
      case 1:
        star = "一星";
        break;
      case 2:
        star = "二星";
        break;
      case 3:
        star = "三星";
        break;
      case 4: //四星
        star = "四星";
        break;
      default:
        //五星
        star = "五星";
        break;
    }
    return star;
  } else {
    return star;
  }
}

const DIFF_REGEX = /^\s*([一|二|三|四|五])星\s*$/;
function getDiffictlutyValue(Diffictluty) {
  const result = DIFF_REGEX.exec(Diffictluty || "");
  if (!result) return 0;
  return "一二三四五".indexOf(result[1]) + 1;
}

const CAN_TRANSFORM_FILE_EXTENSIONS = `
    .txt, .utf8,
    .xml, .php, .properties, .html, .xhtml, .xht, .rng, 
    .htm, .hhc, .hhk, .ini, .lng, .strings, .csv, .lang, 
    .pdf, .odt, .doc, .docx, .dotx, .xls, .xlsx, 
    .ppt, .pptx, .vsdx, .srt, .sla, .svg, .tex, .latex, .po, 
    .rc, .dtd, .hmxp, .sch,  .sbv, .vtt, .tag, .xtg, 
    .resx, .wxl, .txml, .vdx, .jpg, .jpeg, .jpe , .png`.replace(/\s+/g, "");
const TRANSFORM_FILE_EXTENSIONS_REGEX = new RegExp(
  "^" +
    CAN_TRANSFORM_FILE_EXTENSIONS.replace(/\./g, "|")
      .replace(/,/g, "")
      .substr(1) +
    "$"
);

/**
 *
 * @param {String} name
 */
function isFileCanTransform(name) {
  const dotPos = name.lastIndexOf(".");
  if (dotPos < 0 || dotPos >= name.length) return false;
  const extension = name.substr(dotPos + 1);
  return TRANSFORM_FILE_EXTENSIONS_REGEX.test(extension);
}

const FILE_MAXIMUM_SIZE = 1024 * 1024 * 100;
const FILE_MAXIMUM_SIZE_TEXT = `100M`;
/**
 *
 * @param {File} file
 */
function isFileTooLarge(file) {
  return file.size > FILE_MAXIMUM_SIZE;
}

const PREDEFINED_ROLES = {
  teacher: "teacher",
  student: "student",
  schoolMgr: "schoolMgr",
  officialTeachingMgr:"officialTeachingMgr",
  catUser: "catUser"
};

// 记忆库/术语库管理
const TM_LANG_CODES = {
  中文: "zh",
  英语: "en",
  法语: "fr",
  德语: "de",
  日语: "ja",
  俄语: "ru",
  西班牙语: "es",
  阿拉伯语: "ar",

  韩语: "ko",
  越南语: "vi",
  老挝语: "lo",
  柬埔寨语: "km",
  缅甸语: "my",
  泰语: "th",
  马来语: "ms",
  菲律宾语: "fil",
  印尼语: "id",
  印地语: "hi",
  土耳其语: "tr",
  希伯来语: "he",
  "哈萨克语（西里尔文）": "kk",
  "乌兹别克语（拉丁文）": "uz",
  荷兰语: "nl",
  葡萄牙语: "pt",
  瑞典语: "sv",
  意大利语: "it",
  希腊语: "el",
  乌克兰语: "uk",
  匈牙利语: "hu",
  波兰语: "pl",
  捷克语: "cs",
  "塞尔维亚语（西里尔文）": "sr",
  斯瓦希里语: "sw",
};
const TB_LANG_CODES = TM_LANG_CODES;
const ASSET_STATE = {
  uploading: 0,
  processing: 1,
  processed: 2,
  error: 3,
  combining: 4,
  combiningError: 5,
  combined: 6,
  canUse:7,
};
const ASSET_FILE_STATE = {
  uploading: 0,
  processing: 1,
  processed: 2,
  error: 3,
  canUse: 4,
};
const MERGE_STATE = {
  notStart: 0,
  processing: 1,
  processed: 2,
  error: 3,
  canUse: 4,
};
const MERGE_TYPE = {
  merge: 0,
  copy: 1,
};
const ASSET_PERMISSION = {
  private: 0,
  readOnly: 1,
  public: 2,
};

// 新翻译工作坊

const PROJECT_FLOW = {
  single: "翻译",
  double: "翻译 -> 审校",
  triple: "翻译 -> 审校 -> 通读",
};

const PROJECT_FLOW_CODE = {
  single: 0,
  double: 1,
  triple: 2,
};

const PROJECT_STATUS = {
  ready: 0,
  ongoing: 1,
  finished: 2,
  end: 3,
};

const PROJECT_PHASES = {
  translate: 0,
  review: 1,
  proofread: 2,
};

const SELECT_FROM = {
  translate: 0,
  revise: 1,
  finalize: 2,
  group: 3,
}; // 任务分配:判断用户从哪个位置选择的学生

const SYSTEM_CODES = {
  teaching: "1teaching",
  homework: "2homework",
  workshop: "3workshop",
  exam: "4exam",
  train: "5train",
  statistics: "6statistics",
};

const AI_MODULE_CODES = {
  mt: 1,
  lexicalConstraint: 2,
  aiAssistant: 3,
  monolingualTermExtraction: 4,
  bilingualTermExtraction: 5,
}


export {
  SYSTEM_RESPONSE_CODE,
  CORRECT_TYPE,
  CATEGORY_LEVEL,
  STATISTICS_SORT_BASE,
  getSceneList,
  getDiffictluty,
  getDiffictlutyValue,
  translateSubjectTypeToMaterialType,
  CAN_TRANSFORM_FILE_EXTENSIONS,
  isFileCanTransform,
  isFileTooLarge,
  FILE_MAXIMUM_SIZE_TEXT,
  PREDEFINED_ROLES,
  SYSTEM_CODES,
  getSubjectType,

  TM_LANG_CODES,
  TB_LANG_CODES,
  ASSET_STATE,
  ASSET_FILE_STATE,
  MERGE_STATE,
  MERGE_TYPE,
  ASSET_PERMISSION,

  PROJECT_FLOW,
  PROJECT_FLOW_CODE,
  PROJECT_STATUS,
  PROJECT_PHASES,
  SELECT_FROM,

  AI_MODULE_CODES,
};
